<style lang="less" scoped src="../css/common.less"></style>
<style  lang="less" scoped>
  .header-title {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }
    .label{
      display:inline-block;
       // width: 50%;
    }
    .value{
         display:inline-block;
        width: 50%;
        text-align: left;
        padding: 0px;
    }
    .value-t{
         display:inline-block;
        width: 50%;
        text-align: left;
        padding: 0px;
    }
    .value img{
        max-width: 100%;
    }
    .user-flow {
        //padding-left: 120px;
    }
    .flex-contain {
      max-width: 800px;
      display: flex;
      flex-wrap: wrap;
      .line {
        flex: 1;
        margin: 0 5px
      }
    }
</style>
<template>
  <div class="wrap">
    <div v-if="contract.id">
      <div class="flex-contain">
        <div class="line">
          <VTableCard 
            :value="contract"
            :fields="detail_fields"
            cols="12"
          >
            <template v-slot:title>
              <v-ripple-col>
                <span style="white-space:nowrap;font-weight:bold">合同详情</span>
              </v-ripple-col>
            </template>
            <template v-slot:company>
              <v-ripple-col>
                <span style="white-space:nowrap">签署公司：</span>
                <v-spacer />
                <div style="text-align: right;">
                  {{ company_name }}
                </div>
              </v-ripple-col>
            </template>
          </VTableCard>
        </div>
        <div class="line">
          <VTableCard
            :value="contract"
            :fields="df_fields"
            cols="12"
          >
            <template v-slot:title>
              <v-ripple-col>
                <span style="white-space:nowrap;font-weight:bold">对方信息</span>
              </v-ripple-col>
            </template>
          </VTableCard>
        </div>
      </div>
      <div v-if="!!contract.contract_finish_infos&&contract.contract_finish_infos.length">
        <Divider />
        <v-card-text style="margin:10px">
          <div>
            <v-list-item>
              <v-list-item-title>合同预计完结时间</v-list-item-title>
              <v-list-item-subtitle>
                {{ contract.expect_finish_date || contract.contract_end }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>合同状态</v-list-item-title>
              <v-list-item-subtitle>{{ contract.closed?'已完结':'未完结' }}</v-list-item-subtitle>
            </v-list-item>
          </div>
          <v-data-table
       
            dense
            :headers="settle_accounts_headers"
            :items="contract.contract_finish_infos"
            hide-default-footer
            no-data-text="暂无数据"
          >
            <template v-slot:item.is_finish="{ item }">
              {{ item.is_finish?'已完结':'未完结' }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </v-data-table>
        </v-card-text>
      </div>
      <div
        v-if="!!contract"
        style="margin-top: 10px"
      >
        <Tfjs
          :record="contract"
          contract-type="outsource"
          :show-add="showAdd"
          @addTf="addTf"
        />
      </div>
      <div class="line">
        <ExpenseGroupHistory
          relate="outsource_contract_id"
          :relate_id="contract.id"
        />
      </div>
      <Divider />
      <div class="line">
        <div class="label">
          合同附件
        </div>
        <div
          v-if="contract.contract_files.length"
          class="value"
        >
          <Attachments :files="contract.contract_files" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <!--   v-if="is_electronic" -->
      <div
      
        class="line"
      >
        <div class="label">
          电子合同最终版
        </div>
        <div
          v-if="contract.electronic_contract&&contract.electronic_contract.final_contract_file"
          class="value"
        >
          <Attachments :files="[contract.electronic_contract.final_contract_file]" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div class="line">
        <div class="label">
          身份证或护照附件
        </div>
        <div
          v-if="contract.id_files.length"
          class="value"
        >
          <Attachments :files="contract.id_files" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div class="line">
        <div class="label">
          银行卡附件
        </div>
        <div
          v-if="contract.payment_files.length"
          class="value"
        >
          <Attachments :files="contract.payment_files" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div class="line">
        <div class="label">
          归档文件
        </div>
        <div
          v-if="contract.archive_files.length"
          class="value"
        >
          <Attachments :files="contract.archive_files" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div
        v-if="contract.user_flow"
        class="user-flow line"
      >
        <div class="label">
          流程状态
        </div>
        <div class="value-t">
          <UserFlow :user_flow="contract.user_flow" />
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="text-center"
    >
      <Spin
        size="large"
        fix
      />
    </div>
  </div>
</template>
<script>
  import VTableCard from '@/vuetify_custom/v-table-card'
  import VRippleCol from '@/vuetify_custom/v-ripple-col.vue'
  import OSUtil from '../../../outsource/libs/outsource_util';
  import ViewerItem from '../item';
  import Attachments from '../../../components/file/attachments';
  import ExpenseGroupHistory from '../../../expense_group/components/history';
  import { ele_status_hash } from '@/views/outsource/fields.js'
  
  import moment from 'moment'
  import {mapGetters} from "vuex";
  import Tfjs from './Tfjs'
  export default {
    components: { ViewerItem, Attachments, ExpenseGroupHistory, Tfjs, VTableCard, 'v-ripple-col': VRippleCol, },
    props: {
      model_id: {
        type: Number
      },
      modelId: {
        type: Number
      },
      showAdd: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      this.moment = moment
      this.ele_status_hash = ele_status_hash
      return {
        contract: {},
        loading: false
      }
    },
    computed: {
      detail_fields() {
        return [
          {
            key: 'title'
          },
          {
            label: '合同编码：',
            key: 'uid',
          },
          {
            label: '签署公司：',
            key: 'company_id',
            type: 'company_field',
          },
          {
            label: '签署团队：',
            key: 'team_id',
            type: 'team_field'
          },
          {
            label: '申请人',
            key: 'apply_user_id',
            type: 'customer_name_field'
          },
          {
            label: '负责人',
            key: 'pay_user_id',
            type: 'customer_name_field'
          },
          {
            label: '工作内容',
            key: 'job_content',
          },
          {
            label: '是否远程',
            key: 'is_remote',
            type: 'bool_field'
          },
          {
            label: '是否为量产',
            key: 'quantitative_output',
            type: 'bool_field'
          },
          {
            label: '结算方式',
            key: 'settlement_type',
            type: 'select_field',
            value_key: 'value',
            text_key: 'label',
            default_value: 'error 未定义',
            items:   [{
                        label:'计件',
                        value: 'by_piece'
                      },
                      {
                        label:'日薪',
                        value: 'daily_wage'
                      },
                      {
                        label:'月薪',
                        value: 'month_wage'
                      },
                      {
                        label:'按次结算',
                        value: 'per_time'
                      },
                      {
                        label:'按月结算',
                        value: 'per_month'
                      },
                      {
                        label:'其他',
                        value: 'other'
                      }
            ]
          },
          {
            label: '预估金额',
            key: 'estimate_price',
            type: 'money_field'
          },
          {
            label: '生效日期',
            key: 'contract_start',
            
          },
          {
            label: '终止日期',
            key: 'contract_end',
          },
          {
            label: '备注',
            key: 'desc',
          },
          // 预估金额
          // 是否为量产
        ]
      },
      df_fields() {
        return [
          {
            key: 'title'
          },
          {
            label: '姓名：',
            key: 'account',
          },
          {
            label: '人口地区属性：',
            key: 'region',
            type: 'select_field',
            value_key: 'value',
            text_key: 'label',
            default_value: 'error 未定义',
            items:   [
              {
                label: '中国大陆人士',
                value: 'mainland'
              },
              {
                label: '中国港澳台人士',
                value: 'hongkond_macau_taiwan'
              },
              {
                label: '外国人士',
                value: 'foreign'
              }
            ]
          
          },
          {
            label: '联系电话：',
            key: 'mobile'
          },
          {
            label: '支付方式：',
            key: 'payment_type',
            type: 'select_field',
            value_key: 'value',
            text_key: 'label',
            default_value: 'error 未定义',
            items:   [
              {
                label: '银行卡',
                value: 'bank'
              },
              {
                label: '支付宝',
                value: 'alipay'
              },
             
            ]
          },
          {
            label: '银行卡号：',
            key: 'bank_number',
            default_value: '-'
          },
          {
            label: '支付宝账号：',
            key: 'alipay',
            default_value: '-'
          },
        ]
      },
      settle_accounts_headers() {
        return [
          {
            text: '编辑时间',
            align: 'center',
            sortable: false,
            value: 'created_at',
          },
          {
            text: '说明',
            sortable: false,
            value: 'memo',
          },
          {
            text: '状态',
            sortable: false,
            value: 'is_finish',
          },
          {
            text: '负责人',
            align: 'end',
            sortable: false,
            value: 'customer_name',
          }
        ]
      },
      model_id_clone() {
        if (this.model_id !== undefined) {
          return this.model_id
        }
        return this.modelId
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
      company_name() {
        const company = this.companies_hash[this.contract.company_id];
        return company ? company.short_name : '-';
      },
    },
    created() {
      this.getContract();
    },
    mounted() {
      //
    },
    methods: {
      addTf(...params) {
        this.$emit('addTf', ...params)
      },
      getContract() {
        this.loading = true;
        OSUtil.getDetail(this.model_id_clone).then((data) => {
          this.contract = data.contract;
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      formatDecimal(num) {
        return Util.formatDecimal(num);
      },
      fileUrl(filepath) {
        return Util.publicOSSUrl(filepath) + '?x-oss-process=style/preview';
      }
    }
  }
</script>
